import { useEffect, useSyncExternalStore } from 'react';

/**
 * Страница может сузить список языков в переключателе шапки до тех, что она реально переводит.
 * Пока ни одна страница ничего не задала, показываются все языки сайта.
 */
let allowed: readonly string[] | null = null;
const listeners = new Set<() => void>();

const setAllowed = (codes: readonly string[] | null) => {
  allowed = codes;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Коды языков, оставленные страницей (null: ограничений нет). Для шапки. */
export const useAllowedLanguages = (): readonly string[] | null => useSyncExternalStore(subscribe, () => allowed);

/** Для страницы: сузить переключатель языков на время, пока она открыта. Порядок кодов задаёт порядок в меню. */
export const useRestrictLanguages = (codes: readonly string[]): void => {
  const key = codes.join(',');
  useEffect(() => {
    setAllowed(key.split(','));
    return () => setAllowed(null);
  }, [key]);
};
